import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QualityPublication } from '../models/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketQualityService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api`;

  getByTicket(ticketId: string): Promise<QualityPublication[]> {
    return firstValueFrom(
      this.http.get<{ data: QualityPublication[] }>(
        `${this.baseUrl}/ticketcenter/ticket-publishes/ticket/${ticketId}`
      )
    ).then(res => res?.data ?? []);
  }

  create(data: Partial<QualityPublication>): Promise<QualityPublication> {
    return firstValueFrom(
      this.http.post<QualityPublication>(
        `${this.baseUrl}/ticketcenter/ticket-publishes`,
        data
      )
    );
  }

  update(id: string, data: Partial<QualityPublication>): Promise<QualityPublication> {
    return firstValueFrom(
      this.http.patch<QualityPublication>(
        `${this.baseUrl}/ticketcenter/ticket-publishes/${id}`,
        data
      )
    );
  }

  delete(id: string): Promise<unknown> {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}/ticketcenter/ticket-publishes/${id}`)
    );
  }
}
